import BigNumber from "bignumber.js";
import moment from "moment";
export function getSectionName(section, sectionCapital) {
    const id = getId(section);
    const res = sectionCapital.find((item) => item.id.toString() == id);
    if (res === undefined) {
        return null;
    }
    return String(res.name).charAt(0).toUpperCase() + String(res.name).slice(1);
}
function getId(section) {
    if (section === null || section === undefined) {
        return "";
    }
    const slashPos = section.lastIndexOf("/") + 1;
    if (slashPos === 0) {
        return "";
    }
    return section.slice(slashPos);
}
export function projectTypeIcon(project) {
    if (project.applicationType != "common") {
        return "";
    }
    if (findInProjectDescription(project, ["time-shar", "timeshar"])) {
        return "timesharing";
    }
    else {
        return "investment";
    }
}
export function projectTypeName(project) {
    if (project.applicationType != "common") {
        return "";
    }
    if (findInProjectDescription(project, ["time-shar", "timeshar"])) {
        return "Time-Sharing";
    }
    else {
        return "Investing";
    }
}
export function getIsAutenticProject(project) {
    if (project.applicationType != "common") {
        return false;
    }
    return findInProjectDescription(project, ["autentic"]);
}
export function findInProjectDescription(project, substrings) {
    for (const substring of substrings) {
        if (project.descriptionEng && project.descriptionEng.toLowerCase().indexOf(substring) != -1) {
            return true;
        }
    }
    return false;
}
export function formatDate(date) {
    return moment(date).format("DD.MM.YYYY HH:mm");
}
export function formatDateWithMonthName(date) {
    return moment(date).format("MMMM D, YYYY");
}
export function formatDateWithShortMonthName(date) {
    return moment(date).format("MMM D");
}
export function getDatesToEnd(dateTo) {
    return moment(dateTo).diff(moment(new Date()), "days");
}
export function getCurrentPercent(project) {
    let percent = BigNumber(project?.currentCap);
    percent = percent.multipliedBy(100);
    percent = percent.dividedBy(project?.maxCap);
    return Number(percent.toNumber().toFixed(1));
}
export function getStatus(project) {
    if (moment(project.dateStart).isAfter(new Date)) {
        return {
            status: "Waiting",
            statusColor: "#C0C0C0",
            statusIcon: "clock"
        };
    }
    else if (project.isClosed) {
        if (project.isSuccess) {
            if (project?.hasOpenSale && (project.projectType === "invest"
                || project.projectType === "invest_v2")
                && !BigNumber(project?.openSaleLimit).isZero()) {
                return {
                    status: "Open sale",
                    statusColor: "#2aba7c",
                    statusIcon: "rocketc"
                };
            }
            else {
                return {
                    status: "Completed",
                    statusColor: "#C0C0C0",
                    statusIcon: "rocketc"
                };
            }
        }
        else {
            return {
                status: "Declined",
                statusColor: "#1C1C1C",
                statusIcon: "closed"
            };
        }
    }
    else if (moment(new Date).isAfter(project.dateEnd)) {
        return {
            status: "Closed",
            statusColor: "#C0C0C0",
            statusIcon: "rocketc"
        };
    }
    return {
        status: "Open",
        statusColor: "#2aba7c",
        statusIcon: "rocketc"
    };
}
